import type { DashboardStageCounts } from "../services/cases.service";

export interface DashboardChartDatum {
  stage: string;
  total: number;
  clean: number;
  errorsOnly: number;
  blocked: number;
}

export function buildDashboardChartData(
  stages: DashboardStageCounts[]
): DashboardChartDatum[] {
  return stages.map((stage) => {
    const errorsOnly = Math.max(stage.withErrors - stage.blockedWithErrors, 0);
    const clean = Math.max(stage.total - errorsOnly - stage.blocked, 0);
    return {
      stage: stage.stage,
      clean,
      errorsOnly,
      blocked: stage.blocked,
      total: stage.total,
    };
  });
}
